/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chat': {
    width: 31,
    height: 25,
    viewBox: '0 0 31 25',
    data: '<path pid="0" d="M1.346 23.564a4.99 4.99 0 0 0 2.226-1.74C1.377 20.342.001 18.215.001 15.853c0-2.586 1.647-4.889 4.214-6.375.27 6.264 6.919 10.724 14.399 10.724.63 0 1.253-.032 1.87-.093-1.948 2.317-5.438 3.862-9.42 3.862a14.6 14.6 0 0 1-4.111-.58 4.963 4.963 0 0 1-5.637.814.351.351 0 0 1 .03-.64z" _fill="#fff"/><path pid="1" d="M6.226 9.09C6.226 4.07 11.772 0 18.613 0S31 4.07 31 9.09c0 2.646-1.54 5.027-3.999 6.688a5.59 5.59 0 0 0 2.575 1.98.35.35 0 0 1 .04.639 5.57 5.57 0 0 1-6.4-.865 16.35 16.35 0 0 1-4.603.648c-6.841 0-12.387-4.07-12.387-9.09z" _fill="#fff"/>'
  }
})
